import { TextFieldListInterface } from '@/components/textField/TextFieldListInterface';
import { t } from 'i18next';

export const birthSex = (): Array<TextFieldListInterface> => {
  return [
    {
      title: t('male'),
      value: 'M',
    },
    {
      title: t('female'),
      value: 'F',
    },
  /*   {
      title: t('unknown'),
      value: 'O',
    },
    {
      title: t('undifferentiated'),
      value: 'U',
    }, */
  ];
};
